<rid-mechanic-background />

@let _state = state();
@let dur = durationLeft();

<rid-mechanic-wrapper>
  <rid-top-bar
    class="block w-full"
    [name]="'Leeslijst | Timer ' + duration() + 's'"
    [steps]="1"
    [progress]="_state.type === 'INSTRUCTION' || _state.type === 'READING' ? 0 : 1"
  />

  <rid-mechanic-content>
    @if (_state.type !== 'INSTRUCTION') {
      <!-- title -->
      @if (_state.type === 'PROGRESS') {
        <rid-mechanic-title [title]="$textsService.getItem('mechanic.reading-matrix.timer.select-last-read-word')" />
      }

      <!-- matrices -->
      <rid-horizontal-pages [pageCount]="matrices().length" (navigated)="index.set($event)">
        @for (matrix of matricesWithAppearance(); track $index) {
          <rid-word-matrix [matrix]="matrix" (selectionChanged)="select($index, $event.index)" />
        }
      </rid-horizontal-pages>

      <!-- timer -->
      @if (_state.type === 'READING' && dur !== undefined && dur <= 5) {
        <rid-timer
          class="absolute bottom-8 block"
          animate.enter="anim-slide-from-bottom"
          animate.leave="anim-slide-to-bottom"
          [duration]="dur"
        />
      }

      <!-- buttons -->
      @if (_state.type === 'VIEWING') {
        <div class="absolute bottom-8 flex justify-center gap-4">
          <rid-button
            class="w-xs"
            animate.enter="anim-slide-from-bottom"
            animate.leave="anim-slide-to-bottom"
            content="Nog een keer"
            variant="SECONDARY"
            [disabled]="true"
          />
          <rid-button
            class="w-xs"
            animate.enter="anim-slide-from-bottom"
            animate.leave="anim-slide-to-bottom"
            content="Volgende"
            (click)="finish()"
          />
        </div>
      }

      <!-- review toast -->
      @if (_state.type === 'FEEDBACK') {
        <rid-feedback-comparison-toast
          [config]="wordCountComparison"
          [value]="_state.words"
          [previousValue]="previousWordCount()"
          (click)="state.set({ type: 'RATING', selection: _state.selection })"
          (continued)="state.set({ type: 'RATING', selection: _state.selection })"
        />
      }

      <!-- accuracy toast -->
      @if (_state.type === 'ACCURACY_FEEDBACK') {
        <rid-feedback-comparison-toast
          [config]="accuracyComparison"
          [value]="_state.accuracy"
          [previousValue]="previousAccuracy()"
          (click)="finish()"
          (continued)="finish()"
        />
      }

      <!-- overlay -->
      @if (_state.type === 'RATING') {
        <rid-modal-background />
        <rid-rating-modal
          (canceled)="state.set({ type: 'VIEWING', selection: _state.selection })"
          (continued)="rate($event, _state.selection)"
        />
      }
    }

    @if (_state.type === 'INSTRUCTION') {
      <rid-modal-background [blur]="true" />
      <rid-instruction-modal (started)="start()">
        Lees de woorden hardop.<br />Doe dit zo nauwkeurig en snel mogelijk. <br /><br />
        Je hebt hiervoor<br />
        <span class="font-bold"
          ><i-timer class="inline-block size-[1em] -rotate-7" /> {{ duration() + (duration() | plural: ' seconde' : ' seconden') }}</span
        >.
      </rid-instruction-modal>
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
